import { Component, OnInit, Input, Optional, Inject } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { MatRadioChange } from '@angular/material/radio';
import { ExchangeAgreementConfirmLaterDialogComponent } from '../ExchangeAgreementConfirmlaterDialog/exchange-agreement-confirmlater-dialog.component';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { IAppDataStore } from '@pershing/pershing-core';
import { TradingService, TradingEntitlements, Account } from '@pershing/trading-common';

@Component({
    selector: 'exchange-agreement-nyse-np',
    templateUrl: './exchange-agreement-nyse-np.component.html'
})
export class ExchangeAgreementNYSENPComponent implements OnInit {
    @Input() platform: string;
    @Input() public tradingEntitlements: TradingEntitlements = null;

    isbuttonDisabled = true;
    newwindow: any;
    countries: any;
    isDisabled = true;
    firstCheckBox = false;
    secondCheckBox = false;
    selected: string;
    selectedValue: string;
    data: string;
    nonProfQuestions: string[] = [
        'EXCHANGE_AGREEMENT.LABEL_Q1',
        'EXCHANGE_AGREEMENT.LABEL_Q2',
        'EXCHANGE_AGREEMENT.LABEL_Q3',
        'EXCHANGE_AGREEMENT.LABEL_Q4',
        'EXCHANGE_AGREEMENT.LABEL_Q5',
        'EXCHANGE_AGREEMENT.LABEL_Q6',
        'EXCHANGE_AGREEMENT.LABEL_Q7',
        'EXCHANGE_AGREEMENT.LABEL_Q8',
        'EXCHANGE_AGREEMENT.LABEL_Q9',
        'EXCHANGE_AGREEMENT.LABEL_Q10',
        'EXCHANGE_AGREEMENT.LABEL_Q11'];
    nonProfQue1 = [];
    nonProfQue1Sel = [];
    nonProfQueStr = ['', '', '', '', '', '', '', '', '', '', ''];
    isSubmitted: boolean = false;
    subscriberOccupation: any;
    disableTextBox: boolean = false;
    form: FormGroup;
    deviceType: string = 'desktop';
    constructor(
        private http: HttpClient, private dialog: MatDialog,
        private tradingService: TradingService, private appDataStore: IAppDataStore, @Optional() @Inject('AppSettings') appSettings: any) {
            if (!!appSettings.deviceType) {
                this.deviceType = appSettings.deviceType;
            }
    }
    ngOnInit() {
        this.getCountriesList();
        this.getExchangeData();
        this.form = new FormGroup({
            subscriberTitle: new FormControl('', Validators.required),
            employeeName: new FormControl('', Validators.required),
            addressLine1: new FormControl('', Validators.required),
            city: new FormControl('', Validators.required),
            state: new FormControl('', Validators.required),
            zip: new FormControl('', Validators.required),
            country: new FormControl('', Validators.required),
            subscriberOccupation: new FormControl('', Validators.required),
            nonProfQues: new FormControl('', Validators.required),
            agreementIdOne: new FormControl('01')
        });
    }
    getExchangeData() {

        this.tradingService.onAccountListSubject$.subscribe(accounts => {
            // pick the primary account
            let accountToUse = null as Account;
            for (let account of accounts ) {
                if (account.primaryAcct) {
                    accountToUse = account;
                    break;
                }
            }

            // use the first account if none of the account is primary.
            // ideally this should never be executed.
            if (accountToUse === null) {
                accountToUse = accounts[0];
            }
            // this reg edit doesn't work for all the data.
            // this.data = accountToUse.acctAddress.replace(/\b\s{2,}\b/g, '<br/>');
            this.data = accountToUse.acctAddress;

        });

        // get all the accounts and look for the primary account's address.
        // this data will be fetched from the service's cache
        this.tradingService.getAccounts(this.platform);
    }
    disabledTextBox() {

        if (this.subscriberOccupation === 'Retired' || this.subscriberOccupation === 'Not Currently Employed') {
            this.form.get('subscriberTitle').disable();
            this.form.get('employeeName').disable();
            this.form.get('addressLine1').disable();
            this.form.get('city').disable();
            this.form.get('state').disable();
            this.form.get('zip').disable();
            this.form.get('subscriberOccupation').disable();
            this.form.get('country').disable();
        }
    }
    showCancelDialog(): void {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = false;
        dialogConfig.minWidth = '250px';
        dialogConfig.disableClose = true;
        this.dialog.open(ExchangeAgreementConfirmLaterDialogComponent, dialogConfig);
    }
    onFormSubmit() {
        this.isSubmitted = true;
        if (this.form.valid) {
            this.form.value.nonProfQues = this.nonProfQue1Sel;
            let formdata = this.form.value;
            this.appDataStore.put('NONPROFDATA', formdata);
            // this.router.navigate(['/nxi/exchangeagnsdaq'], { queryParamsHandling: 'preserve' });
            // document.dispatchEvent(new CustomEvent('portal.browserTitleValue', {
            //     detail: {
            //         titleValue: 'exchangeagnsdaq'
            //     }
            // }));
            this.tradingService.setExchangeAgreementDialogState('exchangeagnsdaq');
        }
    }
    getCountriesList() {
        this.tradingService.getCountriesList(this.platform).subscribe(
            data => {
                this.countries = data.response as string[];
                console.log(this.countries[1]);
            },
            (err: HttpErrorResponse) => {
                console.log(err.message);
            }
        );
    }
    checkSelected(e: any) {
        if (e.source.id === 'checkbox0') {
            this.firstCheckBox = e.checked;
            console.log('firstc check inside');

        }
        if (e.source.id === 'checkbox1') {
            this.secondCheckBox = e.checked;
            console.log('Second Check inside');
        }
        console.log('outside condition', 'first', this.firstCheckBox, 'second-->', this.secondCheckBox);

        if (this.firstCheckBox && this.secondCheckBox) {

            this.isDisabled = false;

            console.log('inside condition');
        } else {
            this.isDisabled = true;
        }
    }
    changeChk(event: any) {
        if (event.checked) {
            if (this.form.valid) {
                this.isbuttonDisabled = false;
            }
        } else {
            this.isbuttonDisabled = true;
        }
    }
    onChange(radiovalue: MatRadioChange, index: any) {
        if (!this.nonProfQue1.find(arr => arr.index === index)) {
            this.nonProfQue1.push({ value: radiovalue.value, index: index });
            this.nonProfQue1.sort(this.sortByProperty('index'));
        } else {
            this.nonProfQue1.find(arr => arr.index === index).value = radiovalue.value;
        }
        this.nonProfQue1Sel = this.nonProfQue1.map(({ value }) => value);
        if (this.nonProfQueStr.length > index) {
            this.nonProfQueStr[index] = radiovalue.value;
        }
    }
    sortByProperty(property) {
        return (x, y) => {
            return ((x[property] === y[property]) ? 0 : ((x[property] > y[property]) ? 1 : -1));
        };
    }
    checkArrayEmpty() {
        return this.nonProfQueStr.join('') ? true : false;
    }
}
